import { useCallback } from "react";
import { useUser } from "../../context/UserContext";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../../utils/dateHelper";

/**
 * Navigation-trace entries for the Builder (Epic 80429 → Audit & navigation tracing). The
 * app-wide AuditTraceProvider already logs each route change; these add what a route can't say —
 * which definition was opened, which canvas's editor was opened (a dialog, not a route), and the
 * switch to Preview / Run — through the same logAuditTrace queue, in Eastern time.
 */
export const useWorkflowBuilderTrace = () => {
  const { userId } = useUser();

  return useCallback(
    (entry: { objectType: string; objectId: number | null; objectName: string; action: string }) => {
      if (!userId) return;
      logAuditTrace({ userId, ...entry, navigationDateTime: getCurrentESTTime() });
    },
    [userId],
  );
};
